'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.moveToFolderWidget = function (pageController, authenticationModel, googleDriveService, picker) {
	let currentFileId;
	pageController.addEventListener('fileLoaded', function (fileId) {
		currentFileId = fileId;
	});
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.on('click', function () {
			widget.parents().filter(d => d === d.ownerDocument.activeElement).blur();

			authenticationModel.getProfile()
			.then((profile) => picker.pickFolder(profile, 'Select a destination folder'))
			.then((folderId) => googleDriveService.moveToFolder(currentFileId, folderId));
		});
	});
};
